import store from '@/vuex/store'
import util from '@/util'
import router from '@/router'
import {
  ROUTE_NAMES,
} from '@/constant/routes'

const updateQueue = []

let isProcessingQueue = false
const slideId = util.randomIntFromInterval(1, 10000)

const getPresentationGoogleSlide = () => {
  return new Promise((resolve) => {
    if (window.google) {
      window.google.script.run
        .withSuccessHandler(async (info) => {
          resolve(info)
        })
        .withFailureHandler(() => {
          // err là đối tượng ScriptError, có thể in ra message hoặc code
          router.push({
            name: ROUTE_NAMES.PRESENTATION_ERROR_GOOGLE_SLIDE,
          })
          const trackData = {
            eventCategory: 'Google Slide Addon',
            eventAction: 'Get Error Aultiple account',
          }
          util.trackGA4AndMixpanel('Google Slide Addon', trackData)
          // reject(err);
        })
        .getPresentationInfo()
    } else {
      resolve({
        id: `googlePresentationId-${store.state.currentUser.id || 100}`,
        googleSlideId: `googleSlideId-${slideId}`,
        slides: [],
      })
    }
  })
}

const getGoogleSlideActiveId = () => {
  return new Promise((resolve) => {
    if (window.google) {
      window.google.script.run
        .withSuccessHandler(async (info) => {
          resolve(info)
        })
        .getSlideActive()
    } else {
      resolve(`googleSlideId-${slideId}`)
    }
  })
}

const createNewSlideAndSelect = (item, linkPresenting) => {
  return new Promise((resolve) => {
    if (window.google) {
      window.google.script.run.withSuccessHandler(async (info) => {
        resolve(info)
      }).createNewSlideAndSelect(item, linkPresenting)
    } else {
      let idSlide = slideId
      if (item.type === 'leaderboard') {
        idSlide = slideId + util.randomIntFromInterval(1, 10000)
      }
      resolve({
        slideId: `googleSlideId-${idSlide}`,
      })
    }
  })
}

const listenGoogleSlideChangeActive = () => {
  setInterval(async () => {
    if (store.state.isCreatingGoogleSlide) return
    const googleSlideActiveId = await getGoogleSlideActiveId()
    const index = store.state.presentation.slides.findIndex(
      (slide) => slide.googleSlide && slide.googleSlide.googleSlideId === googleSlideActiveId && slide.type !== 'freestyle',
    )

    if (index !== -1) {
      if (store.state.googleSlideActiveId !== store.state.presentation.slides[index].id) {
        if (store.state.presentation.slides[index].type === 'image') {
          store.state.googleSlideActiveId = null
        } else {
          store.state.googleSlideActiveId = store.state.presentation.slides[index].id
        }
        store.dispatch('setSlideActive', {
          id: null,
          activeTab: 1,
        })
      }
    } else if (store.state.slideActive.id || store.state.googleSlideActiveId) {
      store.state.googleSlideActiveId = null
      store.dispatch('setSlideActive', {
        id: null,
        activeTab: 1,
      })
    }
  }, 300)
}

const processQueue = async () => {
  if (isProcessingQueue) {
    return
  }

  isProcessingQueue = true

  while (updateQueue.length > 0) {
    const { title, resolve, reject } = updateQueue.shift()
    try {
      // eslint-disable-next-line no-await-in-loop, no-use-before-define
      await updateActiveSlideTitle(title)
      resolve()
    } catch (error) {
      reject(error)
    }
  }

  isProcessingQueue = false
}

const enqueueUpdateTitle = (title) => {
  return new Promise((resolve, reject) => {
    updateQueue.push({ title, resolve, reject })
    processQueue()
  })
}

const updateActiveSlideTitle = (title) => {
  return new Promise((resolve) => {
    if (window.google) {
      window.google.script.run.withSuccessHandler(async () => {
        resolve()
      }).updateActiveSlideTitle(title)
    } else {
      resolve({
        slideId: `googleSlideId-${slideId}`,
      })
    }
  })
}

const getPresentationName = () => {
  return new Promise((resolve) => {
    if (window.google) {
      window.google.script.run.withSuccessHandler(async (name) => {
        resolve(name)
      }).getPresentationName()
    } else {
      resolve(`presentation-${store.state.currentUser.id}`)
    }
  })
}

const setViewModeBeforeSync = () => {
  return new Promise((resolve) => {
    if (window.google) {
      window.google.script.run.withSuccessHandler(async () => {
        resolve()
      }).setViewModeBeforeSync()
    } else {
      resolve()
    }
  })
}

const getIndexGoogleSlideActive = async () => {
  const googleSlideActiveId = await getGoogleSlideActiveId()
  return store.state.presentation.slides.findIndex(
    (slide) => slide.googleSlide && slide.googleSlide.googleSlideId === googleSlideActiveId,
  )
}

export default {
  getPresentationGoogleSlide,
  createNewSlideAndSelect,
  getGoogleSlideActiveId,
  listenGoogleSlideChangeActive,
  updateActiveSlideTitle,
  enqueueUpdateTitle,
  getPresentationName,
  setViewModeBeforeSync,
  getIndexGoogleSlideActive,
}
